import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledCrossSVG = styled.svg<IconProps>`
  & .cls-1 {
    fill: none;
    stroke: var(--du-color-white, #ffffff);
    stroke-width: 2;
  }
`;

const DrawerCloseIcon: React.FC<IconProps> = ({ active }) => {
  let activeclass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeclass = `${activeclass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledCrossSVG
      id='Cross-Icon-SVG'
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      className={activeclass}
    >
      <rect id='Margin' width='24' height='24' fill='none' />
      <g id='Group_17468' data-name='Group 17468' transform='translate(8 5)'>
        <path
          id='Union_10'
          data-name='Union 10'
          d='M6,7,0,14,6,7,0,0Z'
          transform='translate(10 14) rotate(180)'
          className='cls-1'
        />
      </g>
      <g id='Group_17510' data-name='Group 17510' transform='translate(2 5)'>
        <path
          id='Union_10-2'
          data-name='Union 10'
          d='M6,7,0,14,6,7,0,0Z'
          transform='translate(10 14) rotate(180)'
          className='cls-1'
        />
      </g>
    </StyledCrossSVG>
  );
};

export default DrawerCloseIcon;
